import { render, staticRenderFns } from "./FSocialButton.vue?vue&type=template&id=0ac34a80&"
import script from "./FSocialButton.vue?vue&type=script&lang=js&"
export * from "./FSocialButton.vue?vue&type=script&lang=js&"
import style0 from "./FSocialButton.vue?vue&type=style&index=0&id=0ac34a80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports